/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container-loader[_ngcontent-%COMP%] {\r\n    position: relative;\r\n    height: calc(100% - 5rem);\r\n    width:100%;\r\n    padding-right: 5px;\r\n    display: block;\r\n    background: rgba(255,255, 255, 0.5) ;\r\n    \r\n    min-height: 150px;\r\n}"];
export { styles as styles };
